import { createContext, useContext, ReactNode } from 'react'

const RoleContext = createContext<string>('viewer')

export function RoleProvider({ value, children }: { value: string; children: ReactNode }) {
  return <RoleContext.Provider value={value}>{children}</RoleContext.Provider>
}

export const useRole = () => useContext(RoleContext)
